import React from 'react';
import { FaTimes, FaChevronDown } from 'react-icons/fa';

function UserStatusDropdown({ onClose }) {
  return (
    <div className="user-status-dropdown">
      <div className="dropdown-header">
        <h3>Projects</h3>
        <FaTimes className="close-icon" onClick={onClose} style={{ cursor: 'pointer' }}/>
      </div>
      <div className="dropdown-content">
        <div className="project-item">
          Usama <FaChevronDown />
        </div>
        <div className="project-item selected">
          Free Search
        </div>
      </div>
    </div>
  );
}

export default UserStatusDropdown; 